// extracted by mini-css-extract-plugin
export default {"ComenDiv":"Comentario_ComenDiv__OZ1Z9","nomeC":"Comentario_nomeC__QNeZE","estrela":"Comentario_estrela__MROg0","texto":"Comentario_texto__nyum+"};